/**
 * IMPORTS
 */

import { useQuery } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleBuscarEnderecosSeparadosPorTipo } from "@/domain/use-cases/enderecos/buscar-por-enderecos-por-tipo";

export interface IEnderecoResponse {
  code: number;
  status: string;
  message: string;
  data: {
    residencial: {
      id: number;
      user_id: number;
      logradouro: string;
      numero: string;
      complemento: string;
      bairro: string;
      cidade: string;
      estado: string;
      cep: string;
      ativo: number;
      tipo_endereco: string;
      nome_responsavel: string;
      email: string;
      setor: string;
      telefone: string;
      created_at: string;
      updated_at: string;
      user: {
        id: number;
        nome: string;
        email: string;
        documento: string;
        ativo: number;
        tipo_pessoa: string;
        telefone: string;
        created_at: string;
        updated_at: string;
        deleted_at: string | null;
      };
    };
    entrega: {
      id: number;
      user_id: number;
      logradouro: string;
      numero: string;
      complemento: string;
      bairro: string;
      cidade: string;
      estado: string;
      cep: string;
      ativo: number;
      tipo_endereco: string;
      nome_responsavel: string;
      email: string;
      setor: string;
      telefone: string;
      created_at: string;
      updated_at: string;
      user: {
        id: number;
        nome: string;
        email: string;
        documento: string;
        ativo: number;
        tipo_pessoa: string;
        telefone: string;
        created_at: string;
        updated_at: string;
        deleted_at: string | null;
      };
    };
  };
}

function useBuscarPorEnderecosPorTipo(user_id: number) {
  const { token: accessToken } = useStoreZustandUserAuth();

  // Chave de cache única baseada na página atual e na quantidade de itens por página
  const queryKey = ["enderecos-tipos", user_id];

  const {
    isLoading,
    error: isError,
    data: enderecoResponse,
  } = useQuery<IEnderecoResponse>({
    queryKey,
    enabled: !!user_id && !!accessToken,
    queryFn: async () => {
      const response = await handleBuscarEnderecosSeparadosPorTipo(accessToken!, user_id);

      return response;
    },
    staleTime: 1000 * 60 * 2, // evita múltiplas requisições em 2 min
  });

  const endereco = enderecoResponse?.data ?? null;

  return {
    enderecosTipos: endereco,
    isLoading,
    isError,
  };
}

/**
 * EXPORTS
 */
export { useBuscarPorEnderecosPorTipo };
